import React from 'react';
interface LogoProps {
  tone?: 'light' | 'dark';
  className?: string;
}
export function Logo({
  tone = 'light',
  className = ''
}: LogoProps) {
  const text = tone === 'light' ? 'text-white' : 'text-ink-900';
  const mark = tone === 'light' ? 'stroke-white' : 'stroke-brand-600';
  return <span className={`flex items-center gap-2.5 ${className}`} data-id="element-121" data-mp="3v8edqowp0plh">
      <svg viewBox="0 0 28 24" className={`h-6 w-7 ${mark}`} fill="none" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true" data-id="element-122" data-mp="3v6l91f5n4fg4">
        <path d="M3 6h16" data-id="element-123" data-mp="rr5zsg5369w1" />
        <path d="M3 12h11" data-id="element-124" data-mp="ds6ar7dnvszc" />
        <path d="M14 2.5 25 12 14 21.5" strokeWidth="2.2" data-id="element-125" data-mp="dsxv1m1t64ab" />
      </svg>
      <span className={`text-[19px] font-semibold tracking-[-0.01em] ${text}`} data-id="element-126" data-mp="htrjqhn2rn49">
        Elyon Markets
      </span>
    </span>;
}